import { StoriesType } from './story-model';

export const entryInnerRoutePaths = {
  storiesList: 'listagem-inscricoes',
  newStory: 'nova-inscricao',
  storyStepsBase: 'edicao-inscricao',
  storySteps: 'edicao-inscricao',
  storyResume: 'resumo-inscricao',
  storyReview: 'revisao-inscricao',
} as const;

export const entryRoutePaths = {
  storiesList: `/candidato/${entryInnerRoutePaths.storiesList}`,
  newStory: `/candidato/${entryInnerRoutePaths.newStory}`,
  storyStepsBase: `/candidato/${entryInnerRoutePaths.storyStepsBase}`,
  storySteps: `/candidato/${entryInnerRoutePaths.storySteps}/:step/:id`,
  storyResume: `/candidato/${entryInnerRoutePaths.storyResume}/:id`,
  storyReview: `/candidato/${entryInnerRoutePaths.storyReview}/:id`,
} as const;

interface StoryStepsPathParam {
  step: number;
  id?: number;
}

export function storyStepsPath({ step, id }: StoryStepsPathParam): string {
  const path = entryRoutePaths.storySteps.replace(':step', step + '');

  if (id) {
    return path.replace(':id', id + '');
  }

  return path.replace('/:id', '');
}

export function storiesListPath(tpHistoria?: string): string {
  const tab = tpHistoria === StoriesType.othersStories ? 1 : 0;
  return `${entryRoutePaths.storiesList}?tab=${tab}`;
}
